<template>
    <div>
        <el-row>
      <el-col :span="3">
        {{ valuename }}
      </el-col>
      <el-col :span="1"> {{ "   " }} </el-col>
      <el-col :span="10">
        <el-slider v-model="value" :min="minvalue" :max="maxvalue" :step="valuestep" range></el-slider>
      </el-col>
      <el-col :span="1"> {{ "   " }}  </el-col>
      <el-col :span="3">
      <el-input v-model="value[0]" type="number" placeholder="min"></el-input>
      </el-col>
      <el-col :span="3">
      <el-input v-model="value[1]" type="number" placeholder="max"></el-input>
      </el-col>
    </el-row>
    </div>
</template>

<script>
export default {
  name: 'rangeslider',
  // props: ['valuename', 'minvalue', 'maxvalue', 'valuestep', 'rangevalue'],
  props: {
    valuename: String,
    minvalue: Number,
    maxvalue: Number,
    valuestep: Number,
    value: Array
  },
  watch: {
    myvalue () {
      this.$emit('input', this.myvalue)
    }
  },
  computed: {
    myvalue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.value = newValue
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/subcomponents/rangeslider.vue